import { cx } from '@vizit/theme';
import * as React from 'react';
import { Label, type LabelProps } from 'react-aria-components';

interface _LabelProps extends LabelProps {
  isRequired?: boolean;
}

/**
 * The Label component is used to create a label for a form field.
 *
 * @param props - The props for the Label component.
 * @example
 * <Label>
 *   Label Text
 * </Label>
 */
const _Label = React.forwardRef((props: _LabelProps, ref: React.Ref<HTMLLabelElement>) => {
  const { className, children, isRequired, ...other } = props;

  return (
    <Label
      ref={ref}
      className={cx(
        'font-medium text-sm text-secondary data-[disabled]:cursor-not-allowed peer-disabled:cursor-not-allowed',
        className,
      )}
      {...other}
    >
      {children}
      {isRequired && <span className="text-brand-tertiary ml-1">*</span>}
    </Label>
  );
});

export { _Label as Label };
export type { _LabelProps as LabelProps };
